import { render, staticRenderFns } from "./Bracket2.vue?vue&type=template&id=2f0654ba&scoped=true&"
import script from "./Bracket2.vue?vue&type=script&lang=js&"
export * from "./Bracket2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0654ba",
  null
  
)

export default component.exports